import { waitForRenderThenFocus } from 'platform/utilities/ui';
import { getEditButtonId, getRemoveButtonId } from '../id-factory';

// focusElement did not work on iPhone or Safari for the edit/remove buttons,
// so focus is set once the target has actually rendered.
export const FOCUS_RENDER_INTERVAL = 50;

// How long to wait before re-checking that no modal opened in the meantime.
export const MODAL_RECHECK_DELAY = 100;

const MODAL_SELECTOR = 'va-modal[visible="true"], va-modal[visible]';

export const isAnyModalOpen = () =>
  document.querySelectorAll(MODAL_SELECTOR).length > 0;

/**
 * Whether the field's alert should take focus. Resolves false when a modal is
 * open, so the alert doesn't steal focus from something like the copy address
 * flow. The delayed re-check catches a modal that opens on the same tick.
 *
 * PORT NOTE: the class returned a bare `false` from this branch while its only
 * caller did `.then()` on the result, so an open modal threw
 * "shouldFocusAlert(...).then is not a function" instead of skipping focus.
 * Always returning a promise fixes that.
 */
export const shouldFocusAlert = () => {
  if (isAnyModalOpen()) {
    return Promise.resolve(false);
  }

  return new Promise(resolve => {
    setTimeout(() => resolve(!isAnyModalOpen()), MODAL_RECHECK_DELAY);
  });
};

export const alertSelector = fieldName =>
  `[data-field-name="${fieldName}"] va-alert`;

export const editButtonSelector = fieldName => `#${getEditButtonId(fieldName)}`;

export const removeButtonSelector = fieldName =>
  `#${getRemoveButtonId(fieldName)}`;

export const focusOn = ({ selector, internalSelector }) =>
  waitForRenderThenFocus(
    selector,
    document,
    FOCUS_RENDER_INTERVAL,
    internalSelector,
  );
